import React from 'react';
import { Box, Typography, Grid, Paper, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  AccountBalance,
  Payment,
  Schedule,
  TrendingUp
} from '@mui/icons-material';

const StyledDashboard = styled(Box)(({ theme }) => ({
  padding: '24px',
  backgroundColor: '#121212',
  minHeight: 'calc(100vh - 64px)',
  color: '#ffffff',
}));

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#1a2035',
  borderRadius: '12px',
  border: '1px solid rgba(82,153,255,0.1)',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
  }
}));

const GradientTypography = styled(Typography)(({ theme }) => ({
  background: 'linear-gradient(45deg, #34d399 30%, #38bdf8 90%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 'bold',
}));

const MetricValue = styled(Typography)(({ theme }) => ({
  color: '#34d399',
  fontSize: '2rem',
  fontWeight: 'bold',
  marginBottom: '8px',
}));

const MetricLabel = styled(Typography)(({ theme }) => ({
  color: '#6ee7b7',
  fontSize: '0.875rem',
  textTransform: 'uppercase',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(52, 211, 153, 0.1)',
  borderRadius: '50%',
  padding: '12px',
  marginBottom: '16px',
  width: 'fit-content',
  '& svg': {
    color: '#34d399',
    fontSize: '2rem',
  }
}));

export const PaymentsDashboard: React.FC = () => {
  return (
    <StyledDashboard>
      <Box mb={4}>
        <GradientTypography variant="h4" gutterBottom>
          Payments Dashboard
        </GradientTypography>
        <Typography variant="subtitle1" color="text.secondary">
          Monitor and manage your organization's payment activities
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Quick Stats */}
        <Grid item xs={12} md={3}>
          <StyledCard>
            <CardContent>
              <IconWrapper>
                <AccountBalance />
              </IconWrapper>
              <MetricValue>$45,678</MetricValue>
              <MetricLabel>Total Balance</MetricLabel>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StyledCard>
            <CardContent>
              <IconWrapper>
                <Payment />
              </IconWrapper>
              <MetricValue>$12,345</MetricValue>
              <MetricLabel>Monthly Payments</MetricLabel>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StyledCard>
            <CardContent>
              <IconWrapper>
                <Schedule />
              </IconWrapper>
              <MetricValue>8</MetricValue>
              <MetricLabel>Pending Approvals</MetricLabel>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={3}>
          <StyledCard>
            <CardContent>
              <IconWrapper>
                <TrendingUp />
              </IconWrapper>
              <MetricValue>+15.7%</MetricValue>
              <MetricLabel>Monthly Growth</MetricLabel>
            </CardContent>
          </StyledCard>
        </Grid>

        {/* Main Content Area */}
        <Grid item xs={12}>
          <StyledCard>
            <CardContent>
              <Typography variant="h6" gutterBottom color="white">
                Recent Transactions
              </Typography>
              {/* Add your transactions table or list component here */}
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </StyledDashboard>
  );
}; 